<template>
  <main class="container solution-bedbug">
    <section ref="sectionRef" class="wellcome-section">
      <button class="btn outline">Bed bug Control Solution</button>

      <h2>From Bed bug Infiltration to Swift Control Post-Detection</h2>

      <p>
        CESCO's exclusive regular bed bug monitoring system minimizes the
        <br />
        likelihood of infestations.
      </p>

      <a ref="buttonRef" id="applyButton" :class="[buttonClass, buttonHiddenClass]" href="mailto:'sj.kim@cesco.co.kr'"> Send Email </a>
    </section>

    <img :src="require(`@/assets/images/solution/bedbug/main${mobileCheck ? '_mo' : ''}.png`)" class="main-img" alt="" />

    <section class="section bedbug-issues">
      <div class="contents-center">
        <h3 class="title-section">Bed bug issues are not confined to beds alone.</h3>

        <p class="description-section">
          Known as bloodsucking hitchhikers, <br class="mo_show" />
          bed bugs can travel via all modes of
          <br />
          transportation and infiltrate any space used by people, creating problems.
        </p>

        <div class="layout-d">
          <div class="layout-d-content">
            <div>
              <h4 class="title">
                High proliferation
                <br />
                rate
              </h4>
              <p class="description">
                From 2010 to 2023, a 13-year analysis of bed bug monitoring indices indicates an approximate 16-fold increase, with a high likelihood
                of continued growth.
              </p>
            </div>

            <div class="img-area">
              <h4>2010-2023 Annual Bed Bug Monitoring Index</h4>
              <img src="@/assets/images/solution/bedbug/layout_d_01.svg" alt="" />
              <ul class="list-a">
                <li>Source: CESCO Science Research Institute Big Data</li>
                <li>Bed Bug Monitoring Index: An index developed by CESCO, based on bed bug occurrence and monitoring data.</li>
                <li>Note: This data, derived from CESCO's customer and service records, may not precisely reflect actual bed bug occurrences.</li>
              </ul>
            </div>
          </div>

          <div class="layout-d-content">
            <div>
              <h4 class="title">Persistent reproductive capability</h4>
              <p class="description">
                Two bed bugs can escalate to about 300 adults in 90 days, and by 120 days, roughly 3,000 adults and larvae will have uncontrollably
                spread throughout the entire area. Once established, bed bugs multiply exponentially.
              </p>
            </div>

            <img src="@/assets/images/solution/bedbug/layout_d_02.svg" alt="" />
          </div>

          <div class="layout-d-content">
            <div>
              <h4 class="title fs-40 fw-800">Physical, mental, and economic concerns</h4>
              <p class="fs-24 fw-500 description">
                Bed bug bites may cause sensations of crawling on the skin, high fever, and anemia, necessitating medical treatment. In businesses,
                the economic losses from customer complaints and secondary damages are immeasurable.
              </p>
            </div>

            <div class="card-3">
              <div>
                <img src="@/assets/images/solution/bedbug/layout_d_03.png" alt="" />
                <p>Before Blood Meal</p>
              </div>
              <div>
                <img src="@/assets/images/solution/bedbug/layout_d_04.png" alt="" />
                <p>After Blood Meal</p>
              </div>
            </div>
          </div>

          <div class="layout-d-content">
            <div>
              <h4 class="title fs-40 fw-800">Bed bugs are the most difficulty in pest control</h4>
              <p class="fs-24 fw-500 description">
                Bed bugs are challenging to detect before they feed and can infiltrate continuously via various routes, making them one of the pests
                with the highest control difficulties, and impossible to eradicate completely.
              </p>
            </div>

            <div class="img-area">
              <img class="image" src="@/assets/images/solution/bedbug/layout_d_05.svg" alt="" />
              <ul class="list-a">
                <li>Source: World Quarantine Association, based on the 'Pest and Regional Control Difficulty' standards.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section tab-area">
      <div class="contents-center">
        <div class="pest-invasion-info">
          <h3 class="title-section mb-80">Bed bug Infiltration & Spread</h3>
        </div>

        <div class="tabs">
          <button
            v-for="item in tabList"
            :key="`tab-${item.id}`"
            :id="`tab-${item.id}`"
            :class="['tab-button', tab === item.id && 'active']"
            @click="handleTabClick(item.id)"
          >
            {{ item.name }}
          </button>
        </div>
        <button class="btn-list">Press the button to check.</button>
      </div>

      <div v-if="!mobileCheck" class="tab-contents">
        <div v-if="tab === 0" class="tab-content active" id="tab1">
          <swiper
            :slides-per-view="'auto'"
            :centered-slides="true"
            :loop="true"
            :autoplay="{
              delay: 2000,
              disableOnInteraction: false
            }"
            :modules="[Autoplay]"
            class="bedbug-swiper"
          >
            <swiper-slide>
              <div>
                <h4>High proliferation rate</h4>
                <p>
                  Bed bugs can travel up to 30 meters per day, and if several move in different directions, their spread is significantly broader. If
                  they attach to customers' clothes, bags, boxes in businesses, or cleaning tools, they can spread even faster across the entire
                  business.
                </p>
              </div>

              <div>
                <img src="@/assets/images/solution/bedbug/tab01_01.png" alt="" />
              </div>
            </swiper-slide>

            <swiper-slide>
              <div>
                <h4>Tenacious vitality</h4>
                <p>
                  Bed bugs can travel up to 30 meters per day, and if several move in different directions, their spread is significantly broader. If
                  they attach to customers' clothes, bags, boxes in businesses, or cleaning tools, they can spread even faster across the entire
                  business.
                </p>
              </div>

              <div>
                <img src="@/assets/images/solution/bedbug/tab01_02.png" alt="" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div>
                <h4>Time and cost to get back to normal</h4>
                <p>
                  After bed bugs are discovered and removed, hidden eggs may still hatch.
                  <br />
                  Considering the 9-10 day hatching period for bed bug eggs, multiple rounds of intensive monitoring and removal services are
                  necessary.
                </p>
              </div>

              <div>
                <img src="@/assets/images/solution/bedbug/tab01_03.svg" alt="" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div>
                <h4>Devastating damage</h4>
                <p>
                  A decline in business image and economic losses can be substantial.
                  <br />
                  If bed bugs infest a business, severe complaints can rapidly spread through social media, drastically damaging the business's
                  reputation.
                </p>
              </div>

              <div class="image-slide-1">
                <img src="@/assets/images/solution/bedbug/tab01_04.svg" alt="" />
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div v-if="tab === 1" class="tab-content active" id="tab2">
          <swiper
            :slides-per-view="'auto'"
            :centered-slides="true"
            :loop="true"
            :autoplay="{
              delay: 2000,
              disableOnInteraction: false
            }"
            :modules="[Autoplay]"
            class="bedbug-swiper"
          >
            <swiper-slide>
              <div>
                <h4>Vulnerabilities of multi-use facilities</h4>
                <p>
                  Multi-use facilities are prone to bed bug risks since these pests often enter through people's bags or belongings. Bed bugs can live
                  up to 18 months without feeding, allowing them to inhabit general living facilities for extended periods.
                </p>
              </div>

              <div>
                <img src="@/assets/images/solution/bedbug/tab02_01.svg" alt="" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div>
                <h4>Challenging initial response</h4>
                <p>
                  Bed bugs hide in furniture, walls, outlets, and various crevices, primarily feeding at night. Since general living facilities are
                  busier during the day, detecting hidden bed bugs is challenging, leading to frequent initial response failures. More than 30 days of
                  business closure may be needed for normalization, highlighting the importance of regular monitoring in non-residential facilities.
                </p>
              </div>

              <div>
                <img src="@/assets/images/solution/bedbug/tab02_02.png" alt="" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div>
                <h4>Significant investment of time and resources required for normalization</h4>
                <p>
                  Hotels lacking professional pest management face greater compensation liabilities.
                  <br />
                  For example, P Hotel in New York was sued by six guests who were bitten by bed bugs, resulting in a court order for the hotel to pay
                  130 million won.
                </p>
              </div>

              <div>
                <img src="@/assets/images/solution/bedbug/tab02_03.png" alt="" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div>
                <h4>Necessity for tailored pest control</h4>
                <p>
                  Improper treatments by individuals or non-professionals can exacerbate issues caused by bed bugs and present significant risks,
                  especially to sensitive customers. Therefore, facilities such as hospitals, postnatal care centers, and childcare facilities require
                  expert management.
                </p>
              </div>

              <div>
                <img src="@/assets/images/solution/bedbug/tab01_02.png" alt="" />
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div v-if="tab === 2" class="tab-content active" id="tab3">
          <swiper
            :slides-per-view="'auto'"
            :centered-slides="true"
            :loop="true"
            :autoplay="{
              delay: 2000,
              disableOnInteraction: false
            }"
            :modules="[Autoplay]"
            class="bedbug-swiper"
          >
            <swiper-slide>
              <div>
                <h4>Optimal temperatures for bed bug survival</h4>
                <p>
                  Bed bugs halt development below 13℃ and above 45℃. While eggs can endure up to 39℃, adult bed bugs perish at temperatures exceeding
                  45℃. Nevertheless, bed bugs thrive and are most active within the typical indoor temperature range of 20-25℃ found in human
                  residences.
                </p>
              </div>

              <div>
                <img src="@/assets/images/solution/bedbug/tab03_01.svg" alt="" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div>
                <h4>Susceptibility to invasion in communal housing</h4>
                <p>
                  Due to shared structural features such as passages, pipes, and vents, communal housing provides numerous entry points for bed bugs.
                  These pests can navigate through electrical outlets, door and wall cracks, and vents, easily spreading to adjacent units above or
                  below. Maintaining cleanliness at home alone does not ensure safety from bed bugs.
                </p>
              </div>

              <div class="image-slide-3">
                <img src="@/assets/images/solution/bedbug/tab03_02.png" alt="" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div>
                <h4>Why are homes ideal habitats?</h4>
                <p>
                  Homes offer perfect habitats for bed bugs since they consistently provide humans as a necessary food source.
                  <br />
                  Humans reside and sleep in these spaces daily, emitting carbon dioxide within a 2.4m radius. This zone includes all fabrics,
                  crevices, and outlets around beds, serving as prime activity areas for bed bugs, enabling them to establish habitats throughout the
                  home.
                </p>
              </div>

              <div class="image-slide-3">
                <img src="@/assets/images/solution/bedbug/tab03_03.png" alt="" />
              </div>
            </swiper-slide>
            <swiper-slide>
              <div>
                <h4>Difficulty of control</h4>
                <p>
                  Eliminating bed bugs requires ongoing solutions, such as high-temperature steam disinfection, chemical treatments, and regular
                  habitat checks. Moreover, if the infestation spreads extensively, disposing of all mattresses, bedding, furniture, and housewares
                  may become necessary. As a result, if issues arise at home, the duration of the problem can extend far beyond initial expectations.
                </p>
              </div>

              <div>
                <img src="@/assets/images/solution/bedbug/tab03_04.png" alt="" />
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="contents-center">
        <h3 class="title-section">Once it's out there, it's already too late.</h3>
        <p class="description-section">
          The CESCO Solution includes regular preemptive monitoring, a swift response at the initial stage of infiltration, and the implementation of
          a plan that can quickly restore normalcy when problems occur.
        </p>

        <div class="plan-container">
          <div class="plan-flex">
            <div class="plan-details">
              <p class="plan-title">
                Solutions for Accommodation-Related Facilities /
                <br />
                Residential Homes
              </p>
              <div class="plan-process-group">
                <div class="process-item">
                  <div class="process-step">Process 01</div>
                  <h4 class="process-heading">
                    Continuous Bed bug
                    <br />
                    Monitoring Plan
                  </h4>
                  <p class="process-description">Monitoring Plan</p>
                </div>
                <div class="process-item">
                  <div class="process-step">Process 02</div>
                  <h4 class="process-heading">
                    Bed bug Removal &
                    <br />
                    Normalization Plan
                  </h4>
                  <p class="process-description">Recovery Plan</p>
                </div>
              </div>
            </div>
            <div class="plan-summary">
              <p class="plan-title">
                Solutions for
                <br />
                General Living Facilities
              </p>
              <div class="process-item">
                <div class="process-step">Process 03</div>
                <h4 class="process-heading">
                  Proactive Bed bug
                  <br />
                  Response Service
                </h4>
                <p class="process-description">Prevention</p>
              </div>
            </div>
          </div>
        </div>

        <div class="process-content">
          <div class="process-number">Process 01</div>
          <p class="process-title">
            Continuous Bed bug <br class="mo_show" />
            Monitoring Plan
          </p>
        </div>

        <div>
          <h3 class="diagnosis-title">The Precise and Rapid Diagnosis Solution</h3>
          <p class="diagnosis-description">
            Rapid and accurate diagnosis is crucial for the fastest possible response. <br class="pc_show" />
            CESCO provides strategies to preemptively block bed bug problems and minimize damage.
          </p>
        </div>

        <div class="diagnosis-container">
          <div>
            <div>
              <h4 class="title">Diagnostics by CESCO Experts Using a Precision System</h4>
              <p class="description">
                CESCO pest control experts utilize a system capable of precise diagnostics
                <br />
                to detect signs of bed bugs or their extent, even in the hardest-to-see crevices.
              </p>
            </div>
            <div class="images">
              <img src="@/assets/images/solution/bedbug/diagnosis_01.png" alt="" />
              <img src="@/assets/images/solution/bedbug/diagnosis_02.png" alt="" />
              <img src="@/assets/images/solution/bedbug/diagnosis_03.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section removal-process">
      <div class="contents-center">
        <div class="process-content">
          <div class="process-number">Process 02</div>
          <p class="process-title">Bed bug removal and normalization plan</p>
        </div>

        <div>
          <h3 class="diagnosis-title">Intensive Removal & Normalization Plan Activation</h3>
        </div>

        <div class="diagnosis-container">
          <div>
            <h4 class="title">
              We activate an <br class="mo_show" />
              intensive removal and normalization plan within 24 hours <br class="pc_show" />
              if a problem arises.
            </h4>
            <p class="description">
              Our pest control experts precisely assess the bed bug infiltration situation, applying a combination of physical and chemical controls.
              They conduct a three-step intensive removal process that ensures even newly hatched bed bugs are eliminated, achieving the quickest
              business normalization possible.
            </p>

            <div class="circles">
              <div class="circle">
                <span class="process-number"> STEP 01 </span>
                <h3 class="step-title">Intensive Removal</h3>
              </div>

              <img :src="require(`@/assets/images/solution/bedbug/icon_arrow${mobileCheck ? '_mo' : ''}.svg`)" alt="" />

              <div class="circle">
                <span class="process-number"> STEP 02 </span>
                <h3 class="step-title">Verification of Removal</h3>
              </div>

              <img :src="require(`@/assets/images/solution/bedbug/icon_arrow${mobileCheck ? '_mo' : ''}.svg`)" alt="" />

              <div class="circle">
                <span class="process-number"> STEP 03 </span>
                <h3 class="step-title">
                  Final
                  <br />
                  Monitoring
                </h3>
              </div>
            </div>
          </div>

          <div class="methods">
            <div class="method-card">
              <div>
                <h3 class="title">Chemical Method</h3>
                <p class="description">
                  At the CESCO Technical Research institute, agents are used that have been verified for effectiveness against bed bugs. These
                  treatments take into account the characteristics of each space, furniture and fixture arrangements, and the status of bed bug
                  distribution.
                </p>
              </div>

              <div class="blocks">
                <div class="block full">
                  Verification of Efficacy
                  <br />
                  Against Bed Bugs
                </div>
              </div>
            </div>
            <div class="method-card">
              <div>
                <h3 class="title">Physical Method</h3>
                <p class="description">
                  Professional equipment for first-stage dust collection captures everything from bed bug eggs to adults, followed by a second-stage
                  extermination using high-temperature steam.
                </p>
              </div>
              <div class="blocks">
                <div class="block">
                  1st Stage Dust Collection
                  <br />
                  with Professional
                  <br />
                  Equipment
                </div>

                <img src="@/assets/images/solution/bedbug/icon_plus.svg" class="add-icon" alt="" />

                <div class="block">
                  2nd Stage Extermination
                  <br />
                  with High-Temperature
                  <br />
                  Steam Equipment
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section service-option">
      <div class="contents-center">
        <h2 class="title-section center">Personalized Service Options</h2>

        <div class="bg-img-card-c-2">
          <div class="card">
            <div>
              <span class="option-number"> Product 01 </span>
              <div class="title">
                Bed bug
                <br />
                Diagnosis
                <br />
                Service
              </div>
            </div>
          </div>
          <div class="card">
            <div>
              <span class="option-number"> Product 02 </span>
              <div class="title">
                Regular Bed bug Monitoring
                <br />
                Service
              </div>
            </div>
          </div>
          <div class="card">
            <div>
              <span class="option-number"> Product 03 </span>
              <div class="title">
                Bed bug
                <br />
                Removal
                <br />
                Service
              </div>
            </div>
          </div>
          <div class="card">
            <div>
              <span class="option-number"> Product 04 </span>
              <div class="title">Bed bug Disinfection Service</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section ref="checkSectionRef" class="sub-footer">
      <h2>
        We have a range of bed bug control <br />
        solutions for your situation.
      </h2>
      <p>If you are concerned about bed bug <br class="mo_show" />issues, consult a pest control expert <br />immediately!</p>
      <a class="btn" href="mailto:'sj.kim@cesco.co.kr'"> Send Email </a>
    </section>
  </main>

  <ModalView v-if="mobileCheck" :modal-state="modalState" @close-modal="closeModal">
    <BedbugModalContent :tab="tab" :text="tabList[tab].name" />
  </ModalView>
</template>

<script setup>
import { inject } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay } from 'swiper/modules'
import { useScroll, useModal, useTab } from '@/hooks'
import ModalView from '@/components/common/ModalView.vue'
import BedbugModalContent from '@/components/modal/BedbugModalContent.vue'

const { sectionRef, checkSectionRef, buttonRef, buttonClass, buttonHiddenClass } = useScroll()
const { modalState, openModal, closeModal } = useModal()
const { tab, handleTabClick } = useTab(openModal)

const mobileCheck = inject('mobileCheck')

const tabList = [
  { id: 0, name: `Accommodation-Related  Facilitie` },
  { id: 1, name: 'General Living Facilities' },
  { id: 2, name: 'Homes' }
]
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/bedbug.scss';
</style>
